import { render, staticRenderFns } from "./data-performance-score.vue?vue&type=template&id=2966ac04&scoped=true&"
import script from "./data-performance-score.vue?vue&type=script&lang=js&"
export * from "./data-performance-score.vue?vue&type=script&lang=js&"
import style0 from "./data-performance-score.vue?vue&type=style&index=0&id=2966ac04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966ac04",
  null
  
)

component.options.__file = "data-performance-score.vue"
export default component.exports